/** @format */

import React, { useState, useEffect, useRef } from "react";
import SecureStorage from "react-secure-storage";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../css/ReportPageMobile.css";
import { Modal } from "bootstrap";

import * as funcAll from "../../util/funcAll";

import NavbarMobile from "./NavbarMobile";
import ReportMobileTH from "./ReportMobileTH";
import ReportMobileEN from "./ReportMobileEN";
import FollowMobileTH from "./FollowMobileTH";
import FollowMobileEN from "./FollowMobileEN";
import FooterTH from "../menu/Footer-TH";
import FooterEN from "../menu/Footer-EN";

/////////////   Redux  //////////////
import { saveLanguageWeb } from "../store/LanguageSlice";
import { useSelector, useDispatch } from "react-redux";

const constants = require("file-configs/constants");

export default function ReportPageMobile(props) {
  const dispatch = useDispatch();
  const globalData = useSelector((state) => ({ ...state }));
  const [openBurger, setOpenBurger] = useState(false);
  const [typePage, setTypePage] = useState("report");

  function handleOpenBurger() {
    setOpenBurger(!openBurger);
  }

  function handleBtnWindowBurgerClick(type) {
    setOpenBurger(false);
    if (type === "report") {
      setTypePage(type);
    }
    if (type === "follow") {
      setTypePage(type);
    }
  }

  const handleGoFollowPage = (check) => {
    if (check === true) {
      setTypePage("follow");
    }
  };

  return (
    <div
      style={{
        backgroundColor: "#fff",
      }}>
      <NavbarMobile
        checkOpenBurger={handleOpenBurger}
        openBurger={openBurger}
        type={typePage}
      />

      {openBurger === true ? (
        <div className="window-openBurger">
          <div className="container-btn">
            <button
              className="btn"
              onClick={() => handleBtnWindowBurgerClick("report")}>
              <i
                class="fa-regular fa-message"
                style={{ marginRight: "1rem" }}></i>

              <p>
                {globalData.language.toggle_language === true
                  ? "แจ้งเรื่องใหม่"
                  : "Submit New Issue"}
              </p>
            </button>

            <button
              className="btn"
              style={{ marginTop: "0" }}
              onClick={() => handleBtnWindowBurgerClick("follow")}>
              <i
                class="fa-regular fa-rectangle-list"
                style={{ marginRight: "1rem" }}></i>
              <p>
                {globalData.language.toggle_language === true
                  ? "ติดตามความก้าวหน้า"
                  : "Track progress"}
              </p>
            </button>
          </div>
        </div>
      ) : null}

      {globalData.language.toggle_language === true ? (
        <>
          {typePage === "report" ? (
            <ReportMobileTH
              goToFollowPage={(check) => handleGoFollowPage(check)}
            />
          ) : (
            <FollowMobileTH />
          )}
        </>
      ) : (
        <>
          {typePage === "report" ? (
            <ReportMobileEN
              goToFollowPage={(check) => handleGoFollowPage(check)}
            />
          ) : (
            <FollowMobileEN />
          )}
        </>
      )}

      {globalData.language.toggle_language === true ? (
        <FooterTH />
      ) : (
        <FooterEN />
      )}
    </div>
  );
}
